import React from 'react'

import { Field } from 'formik'

import { Form, Col } from '_zari/core'

import { KeyEventUtil } from 'utils'

const SerieNumeroFormGroup = ({ fIsSubmitting, iErrorSerie, iTouchedSerie, iErrorNumero, iTouchedNumero }) => {
  const onKeyDown = React.useCallback(e => {
    KeyEventUtil.leaveOnEnterOrTab('input-numeroDocumento', e)
  }, [])

  const onKeyDown2 = React.useCallback(e => {
    KeyEventUtil.leaveOnEnterOrTab('select-moneda', e)
  }, [])

  return (
    <>
      <Form.Group>
        <Form.Label text='SERIE' htmlFor='input-serieDocumento' md={4} alignRightAt='md' />
        <Col md={4}>
          <Field name='serieDocumento'>
            {({ field }) => (
              <Form.InputText
                {...field}
                id='input-serieDocumento'
                disabled={fIsSubmitting}
                className='zr-text-upper'
                isInvalid={iTouchedSerie && iErrorSerie}
                maxLength={4}
                onKeyDown={onKeyDown}
              />
            )}
          </Field>
          {iTouchedSerie && iErrorSerie ? <Form.Feedback type='invalid'>{iErrorSerie}</Form.Feedback> : null}
        </Col>
        <Col md={4} className='pl-0'>
          <Field name='numeroDocumento'>
            {({ field }) => (
              <Form.InputNumber
                {...field}
                id='input-numeroDocumento'
                disabled={fIsSubmitting}
                onKeyDown={onKeyDown2}
                isInvalid={iTouchedNumero && iErrorNumero}
              />
            )}
          </Field>
          {iTouchedNumero && iErrorNumero ? <Form.Feedback type='invalid'>{iErrorNumero}</Form.Feedback> : null}
        </Col>
      </Form.Group>
    </>
  )
}

export default React.memo(SerieNumeroFormGroup)
